/* unplugin-vue-components disabled */import { render } from "./member_new.vue?vue&type=template&id=1fbac0b0&scoped=true"
import script from "./member_new.vue?vue&type=script&lang=js"
export * from "./member_new.vue?vue&type=script&lang=js"

import "./member_new.vue?vue&type=style&index=0&id=1fbac0b0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fbac0b0"]])

export default __exports__